import axios, { AxiosError } from 'axios';
import { AppError } from 'merchant-api';

export const spiceroad = axios.create({
  baseURL: import.meta.env['VITE_SPICEROAD_URL'],
  withCredentials: true,
});

spiceroad.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) throw AppError.Unauthenticated;
    if (error.response?.status === 403) throw AppError.Unauthenticated;
    return Promise.reject(error);
  }
);

export * from './useTransactions/useTransactions';
export * from './usePersons/usePersons';
export * from './useDocuments/useDocuments';
export * from './useParties/useParties';
export * from './useLoan/useLoan';
export * from './useDrawPreview/useDrawPreview'
export * from './getDocument/getDocument'
export * from './useDrawCreate/useDrawCreate';
export * from './getBusiness/getBusiness';
export * from './getBusiness/getBusinessMock';
export * from './getOPTData/getOPTData';
export * from './postOTP/postOTP';
export * from './getRenewal/getRenewal';
export * from './getTransactionCSV/getTransactionCSV';
export * from './useLOC/useLOC';
export * from './getTLPayment/getTLPayment';
export * from './getLOCPayment/getLOCPayment';
export * from './usePlaid/usePlaid';
export * from './postSession/postSession';
export * from './getLDR/getLDR';
export * from './getSalesAgentInfo/getSalesAgentInfo';
export * from './uploadDocuments/uploadDocuments';
export * from './useParties/partiesMock';
export * from './useMerchantValidation/useMerchantValidation';
export * from './getMerchantProfile/getMerchantProfile';
export * from './getPlaidInfo/getPlaidInfo';
export * from './updateLDRs/updateLDRs';
export * from './getInstantFundingTermsAndConditions/getInstantFundingTermsAndConditions';
export * from './getInstantFundingTermsAndConditions/termsAndConditionsMock'
export * from './postTermsAndConditions/postTermsAndConditions'
export * from './checkInstitutionSupport/checkInstitutionSupport'
export * from './associateApp/associateApp';
export * from './useLoan/useBatchLoan';
